import * as s from '~js/utils/selectors';
import * as a from '~js/utils/attributes';
import * as c from '~js/utils/classes';
import * as stngs from '~js/utils/settings';
import { Collapsible } from '~js/components/collapsible';
import { QuantityCounter } from '~js/components/quantity-counter';
import { NotificationPopup } from '~js/components/notification-popup';
import { QuickViewPopup } from '~js/components/quick-view-popup';
import { a11y } from '~js/components/a11y';
import {
  throttle,
} from '~js/utils/utils';


const themeCurrency = themeVendor.themeCurrency;
const Flickity = themeVendor.Flickity;

export class CartDrawer {
  constructor() {
    if (window.location.pathname === '/password') {
      return;
    }

    this.init();
    this.bindEvents();
  }

  init() {
    // DOM Elements
    this.cartToggleButtons = document.querySelectorAll(s.selectors$J.cartDrawerToggle);
    this.cartPage = document.querySelector(s.selectors$J.cartPage);
    this.cartDrawer = document.querySelector(s.selectors$J.cartDrawer);
    this.cart = this.cartDrawer || this.cartPage;

    this.cartCount = this.getCartItemCount();

    this.assignArguments();

    this.recipientErrors = this.form?.getAttribute(a.attributes$s.recipientError) === 'true';
    this.flktyUpsell = null;
    this.form = null;
    this.collapsible = null;
    this.a11y = a11y;

    this.build = this.build.bind(this);

    // AJAX request
    this.addToCart = this.addToCart.bind(this);
    this.updateCart = this.updateCart.bind(this);

    // Cart events
    this.openCartDrawer = this.openCartDrawer.bind(this);
    this.closeCartDrawer = this.closeCartDrawer.bind(this);
    this.toggleCartDrawer = this.toggleCartDrawer.bind(this);
    this.formSubmitHandler = throttle(this.formSubmitHandler.bind(this), 50);
    this.closeCartError = () => {
      this.cartErrorHolder.classList.remove(c.classes$z.expanded);
    };
    this.cartDrawerCloseEvent = null;

    // Checking
    this.hasItemsInCart = this.hasItemsInCart.bind(this);
    this.isCartPage = Boolean(this.cart && this.cartDrawer === null);
    this.showAnimations = Boolean(document.body.dataset.animations === 'true');

    // Set classes
    this.toggleClassesOnContainers = this.toggleClassesOnContainers.bind(this);

    // Flags
    this.totalItems = 0;
    this.isCartDrawerOpen = false;
    this.isCartDrawerLoaded = false;
    this.cartDiscounts = 0;
    this.cartDrawerEnabled = stngs.settings$4.cartDrawerEnabled;
    this.cartAnimationTimer = 0;
    this.cartUpdateFailed = false;

    // Cart Events
    this.cartEvents();
    this.cartAddEvent();
    this.cartDrawerToggleEvents();

    // Init quantity for fields
    this.initQuantity();

    // Init collapsible function for the cart accordions
    if (this.buttonHolder) {
      this.collapsible = new Collapsible(this.buttonHolder);
    }

    if (this.isCartPage) {
      this.renderPairProducts();
      // Ensure keyboard accessibility for cart page
      this.ensureCartPageKeyboardAccess();
    }

    document.addEventListener('theme:popup:open', this.closeCartDrawer);
  }

  bindEvents() {
    // ... existing event bindings ...
    console.log('bindEvents called', this.cart);

    this.cart.addEventListener('click', (event) => {
      const bundleRemoveButton = event.target.closest('[data-bundle-remove-button]');

      if (bundleRemoveButton) {
        event.preventDefault();
        console.log('bundle remove button clicked', bundleRemoveButton);
        const bundleKey = bundleRemoveButton.dataset.bundleKey;

        console.log('bundleKey', bundleKey);

        this.removeBundleItems(bundleKey);
      }
    });
  }

  /**
   * Assign cart constructor arguments on page load or after cart drawer is loaded
   *
   * @return  {Void}
   */
  assignArguments() {
    this.cartDrawerBody = document.querySelector(s.selectors$J.cartDrawerBody);
    this.emptyMessage = document.querySelector(s.selectors$J.emptyMessage);
    this.buttonHolder = document.querySelector(s.selectors$J.buttonHolder);
    this.itemsHolder = document.querySelector(s.selectors$J.itemsHolder);
    this.cartItemsQty = document.querySelector(s.selectors$J.cartItemsQty);
    this.itemsWrapper = document.querySelector(s.selectors$J.itemsWrapper);
    this.items = document.querySelectorAll(s.selectors$J.item);
    this.cartTotal = document.querySelector(s.selectors$J.cartTotal);
    this.cartTotalPrice = document.querySelector(s.selectors$J.cartTotalPrice);
    this.cartMessage = document.querySelectorAll(s.selectors$J.cartMessage);
    this.cartOriginalTotal = document.querySelector(s.selectors$J.cartOriginalTotal);
    this.cartErrorHolder = document.querySelector(s.selectors$J.cartErrors);
    this.cartCloseErrorMessage = document.querySelector(s.selectors$J.cartCloseError);
    this.pairProductsHolder = document.querySelector(s.selectors$J.pairProductsHolder);
    this.pairProducts = document.querySelector(s.selectors$J.pairProducts);
    this.priceHolder = document.querySelector(s.selectors$J.priceHolder);
    this.upsellHolders = document.querySelectorAll(s.selectors$J.upsellHolder);
    this.cartTermsCheckbox = document.querySelector(s.selectors$J.cartTermsCheckbox);
    this.cartCheckoutButtonWrapper = document.querySelector(s.selectors$J.cartCheckoutButtonWrapper);
    this.cartCheckoutButton = document.querySelector(s.selectors$J.cartCheckoutButton);
    this.cartForm = document.querySelector(s.selectors$J.cartForm);
    this.cartItemCount = 0;
    this.subtotal = window.theme.subtotal;
    this.button = null;

    if (this.cartMessage.length > 0) {
      this.cartFreeLimitShipping =
        Number(this.cartMessage[0].getAttribute(a.attributes$s.shippingMessageLimit)) *
        100 *
        window.Shopify.currency.rate;
    }

    this.updateProgress();
  }

  /**
   * Init quantity field functionality
   *
   * @return  {Void}
   */

  initQuantity() {
    this.items = document.querySelectorAll(s.selectors$J.item);

    this.items?.forEach((item) => {
      const quantity = new QuantityCounter(item, true);

      quantity.init();
      this.cartUpdateEvent(item);
    });
  }

  /**
   * Custom event who change the cart
   *
   * @return  {Void}
   */

  cartUpdateEvent(item) {
    item.addEventListener('theme:cart:update', (event) => {
      this.updateCart(
        {
          id: event.detail.id,
          quantity: event.detail.quantity,
        },
        item
      );
    });
  }

  /**
   * Cart events
   *
   * @return  {Void}
   */

  cartEvents() {
    const cartItemRemove = document.querySelectorAll(s.selectors$J.cartItemRemove);
    this.totalItems = cartItemRemove.length;

    cartItemRemove?.forEach((button) => {
      const item = button.closest(s.selectors$J.item);
      button.addEventListener('click', (event) => {
        event.preventDefault();

        if (button.classList.contains(c.classes$z.disabled)) return;

        this.updateCart(
          {
            id: item.getAttribute(a.attributes$s.dataId),
            quantity: 0,
          },
          item
        );
      });
    });

    if (this.cartCloseErrorMessage) {
      this.cartCloseErrorMessage.removeEventListener('click', this.closeCartError);
      this.cartCloseErrorMessage.addEventListener('click', this.closeCartError);
    }

    if (this.cartTermsCheckbox) {
      this.cartTermsCheckbox.removeEventListener('change', this.formSubmitHandler);
      this.cartCheckoutButtonWrapper.removeEventListener('click', this.formSubmitHandler);
      this.cartForm.removeEventListener('submit', this.formSubmitHandler);

      this.cartTermsCheckbox.addEventListener('change', this.formSubmitHandler);
      this.cartCheckoutButtonWrapper.addEventListener('click', this.formSubmitHandler);
      this.cartForm.addEventListener('submit', this.formSubmitHandler);
    }
  }

  /**
   * Cart event add product to cart
   *
   * @return  {Void}
   */

  cartAddEvent() {
    document.addEventListener('click', (event) => {
      const clickedElement = event.target;
      const isButtonATC = clickedElement?.matches(s.selectors$J.buttonAddToCart);
      const getButtonATC = clickedElement?.closest(s.selectors$J.buttonAddToCart);

      if (isButtonATC || getButtonATC) {
        event.preventDefault();

        this.button = isButtonATC ? clickedElement : getButtonATC;
        this.form = clickedElement.closest('form');
        this.recipientErrors = this.form?.getAttribute(a.attributes$s.recipientError) === 'true';
        this.formWrapper = this.button.closest(s.selectors$J.formWrapper);
        const isVariantSoldOut = this.formWrapper?.classList.contains(c.classes$z.variantSoldOut);
        const isButtonDisabled = this.button.hasAttribute(a.attributes$s.disabled);
        const isQuickViewOnboarding = this.button.closest(s.selectors$J.quickViewOnboarding);
        const hasDataAtcTrigger = this.button.hasAttribute(a.attributes$s.atcTrigger);
        const hasNotificationPopup = this.button.hasAttribute(a.attributes$s.notificationPopup);
        const hasFileInput = this.form?.querySelector('[type="file"]');

        if (isButtonDisabled || hasFileInput || isQuickViewOnboarding) return;

        // Notification popup
        if (isVariantSoldOut && hasNotificationPopup) {
          new NotificationPopup(this.button);
          return;
        }

        if (hasDataAtcTrigger) {
          this.a11y.state.trigger = this.button;
        }

        const formData = new FormData(this.form);

        if (this.button.hasAttribute('data-add-both-to-cart')) {
          
          this.mainAddToCartBtn = document.querySelector('.product-single__details .product__block.product__form__wrapper form [data-add-to-cart]');

          if(this.mainAddToCartBtn && !this.mainAddToCartBtn.hasAttribute('data-current-variant-unavailable')) {
            this.addToCart(formData, 'add_both_to_cart');
          } else {
            this.addToCart(formData);
          }
        } else {
          this.addToCart(formData);
        }

        // Hook for cart/add.js event
        document.dispatchEvent(
          new CustomEvent('theme:cart:add', {
            bubbles: true,
            detail: {
              selector: clickedElement,
            },
          })
        );
      }
    });
  }

  /**
   * Get response from the cart
   *
   * @return  {Void}
   */

  getCart() {
    // Render cart drawer if it exists but it's not loaded yet
    if (this.cartDrawer && !this.isCartDrawerLoaded) {
      const alwaysOpen = false;
      this.renderCartDrawer(alwaysOpen);
    }

    fetch(theme.routes.cart_url + '?section_id=api-cart-items')
      .then(this.handleErrors)
      .then((response) => response.text())
      .then((response) => {
        const element = document.createElement('div');
        element.innerHTML = response;

        const cleanResponse = element.querySelector(s.selectors$J.apiContent);
        this.build(cleanResponse);
      })
      .catch((error) => console.log(error));
  }

  /**
   * Add item(s) to the cart and show the added item(s)
   *
   * @param   {String}  data
   * @param   {DOM Element}  button
   *
   * @return  {Void}
   */

  addToCart(data, action = '') {
    if (this.cartDrawerEnabled && this.button) {
      this.button.classList.add(c.classes$z.loading);
      this.button.setAttribute(a.attributes$s.disabled, true);
    }
    
    fetch(theme.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/javascript',
      },
      body: data,
    })
      .then((response) => response.json())
      .then((response) => {
        this.button.disabled = true;
        this.addLoadingClass();

        if (response.status) {
          this.addToCartError(response);
          this.removeLoadingClass();
          return;
        }

        this.hideAddToCartErrorMessage();

        if(action === 'add_both_to_cart') {
          setTimeout(() => {
            this.mainAddToCartBtn.click();
          }, 500);
          return;
        }

        if (this.cartDrawerEnabled) {
          this.getCart();
        } else {
          window.location = theme.routes.cart_url;
        }
      })
      .catch((error) => console.log(error));
  }

  /**
   * Remove multiple items from the cart
   * @param {String} parentVariantId  - Array of variant IDs to remove
   * @param {Array} childVariantIds - Array of variant IDs to remove
   * 
   */
  removeBundleItems(bundleKey) {
    // Add loading class to the cart drawer
    this.addLoadingClass();
    this.disableCartButtons();

    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            // Find all items with this bundle key, including the tray
            const itemsToRemove = cart.items.filter(item => 
                item.properties && 
                item.properties._bundle_key === bundleKey
            );

            // Create a unique key for each line item using both variant ID and bundle key
            const updates = {};
            itemsToRemove.forEach(item => {
                updates[item.key] = 0;
            });

            return fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ updates })
            });
        })
        .then(response => response.json())
        .then(updatedCart => {
            this.getCart();
        })
        .catch(error => {
            console.error('Error removing bundle:', error);
            this.removeLoadingClass();
            this.enableCartButtons();
        });
  }


  /**
   * Update cart
   *
   * @param   {Object}  updateData
   *
   * @return  {Void}
   */

  updateCart(updateData = {}, currentItem = null) {
    let updatedQuantity = updateData.quantity;
    
    // Store previous state for announcements
    const previousQuantity = currentItem 
      ? parseInt(currentItem.querySelector(s.selectors$J.qtyInput)?.value || 0)
      : 0;
    const itemTitle = currentItem?.hasAttribute(a.attributes$s.itemTitle)
      ? currentItem.getAttribute(a.attributes$s.itemTitle)
      : null;
    
    if (currentItem !== null) {
      if (updatedQuantity) {
        currentItem.classList.add(c.classes$z.loading);
      } else {
        currentItem.classList.add(c.classes$z.removed);
      }
    }
    this.disableCartButtons();
    this.addLoadingClass();

    const newItem = this.cart.querySelector(`[${a.attributes$s.item}="${updateData.id}"]`) || currentItem;
    const lineIndex = newItem?.hasAttribute(a.attributes$s.itemIndex)
      ? parseInt(newItem.getAttribute(a.attributes$s.itemIndex))
      : 0;

    if (lineIndex === 0) return;

    const data = {
      line: lineIndex,
      quantity: updatedQuantity,
    };

    fetch(theme.routes.cart_change_url, {
      method: 'post',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.status === 400) {
          const error = new Error(response.status);
          this.cartDrawerEnabled ? this.getCart() : (window.location = theme.routes.cart_url);
          throw error;
        }

        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        if (parsedState.errors) {
          this.cartUpdateFailed = true;
          this.updateErrorText(itemTitle);
          this.toggleErrorMessage();
          this.resetLineItem(currentItem);
          this.enableCartButtons();
          this.removeLoadingClass();

          return;
        }

        // Announce quantity change or removal before updating cart
        if (updatedQuantity === 0 && itemTitle) {
          this.announceItemRemoval(itemTitle);
        } else if (updatedQuantity !== previousQuantity && itemTitle) {
          this.announceQuantityChange(itemTitle, previousQuantity, updatedQuantity);
        }

        this.getCart();
      })
      .catch((error) => {
        console.log(error);
        this.enableCartButtons();
        this.removeLoadingClass();
      });
  }

  /**
   * Reset line item initial state
   *
   * @return  {Void}
   */
  resetLineItem(item) {
    const qtyInput = item.querySelector(s.selectors$J.qtyInput);
    const qty = qtyInput.getAttribute('value');
    qtyInput.value = qty;
    item.classList.remove(c.classes$z.loading);
  }

  /**
   * Disable cart buttons and inputs
   *
   * @return  {Void}
   */
  disableCartButtons() {
    const inputs = this.cart.querySelectorAll('input');
    const buttons = this.cart.querySelectorAll(`button, ${s.selectors$J.cartItemRemove}`);

    if (inputs.length) {
      inputs.forEach((item) => {
        item.classList.add(c.classes$z.disabled);
        item.blur();
        item.disabled = true;
      });
    }

    if (buttons.length) {
      buttons.forEach((item) => {
        item.setAttribute(a.attributes$s.disabled, true);
        // Ensure disabled buttons are not keyboard accessible
        if (item.hasAttribute('tabindex') && item.getAttribute('tabindex') !== '-1') {
          item.setAttribute('data-tabindex-backup', item.getAttribute('tabindex'));
        }
        item.setAttribute('tabindex', '-1');
        item.setAttribute('aria-disabled', 'true');
      });
    }
  }

  /**
   * Enable cart buttons and inputs
   *
   * @return  {Void}
   */
  enableCartButtons() {
    const inputs = this.cart.querySelectorAll('input');
    const buttons = this.cart.querySelectorAll(`button, ${s.selectors$J.cartItemRemove}`);

    if (inputs.length) {
      inputs.forEach((item) => {
        item.classList.remove(c.classes$z.disabled);
        item.disabled = false;
      });
    }

    if (buttons.length) {
      buttons.forEach((item) => {
        item.removeAttribute(a.attributes$s.disabled);
        item.removeAttribute('aria-disabled');
        // Restore tabindex if it was backed up
        if (item.hasAttribute('data-tabindex-backup')) {
          item.setAttribute('tabindex', item.getAttribute('data-tabindex-backup'));
          item.removeAttribute('data-tabindex-backup');
        } else if (item.getAttribute('tabindex') === '-1' && item.tagName === 'BUTTON') {
          // Remove tabindex from native buttons to restore default behavior
          item.removeAttribute('tabindex');
        }
      });
    }
  }

  /**
   * Update error text
   *
   * @param   {String}  itemTitle
   *
   * @return  {Void}
   */

  updateErrorText(itemTitle) {
    this.cartErrorHolder.querySelector(s.selectors$J.errorMessage).innerText = itemTitle;
  }

  /**
   * Toggle error message
   *
   * @return  {Void}
   */

  toggleErrorMessage() {
    if (!this.cartErrorHolder) return;

    this.cartErrorHolder.classList.toggle(c.classes$z.expanded, this.cartUpdateFailed);

    if (this.cartUpdateFailed) {
      const cartCloseError = this.cartErrorHolder.querySelector(s.selectors$J.cartCloseError);
      this.focusOnErrorMessage(this.cartErrorHolder, cartCloseError);
    }

    // Reset cart error events flag
    this.cartUpdateFailed = false;
  }

  /**
   * Handle errors
   *
   * @param   {Object}  response
   *
   * @return  {Object}
   */

  handleErrors(response) {
    if (!response.ok) {
      return response.json().then(function (json) {
        const e = new FetchError({
          status: response.statusText,
          headers: response.headers,
          json: json,
        });
        throw e;
      });
    }
    return response;
  }

  /**
   * Add to cart error handle
   *
   * @param   {Object}  data
   * @param   {DOM Element/Null} button
   *
   * @return  {Void}
   */

  addToCartError(data) {
    const buttonQuickBuyForm = this.button.closest(s.selectors$J.quickBuyForm);
    const buttonUpsellHolder = this.button.closest(s.selectors$J.upsellHolder);
    const isFocusEnabled = !document.body.classList.contains(c.classes$z.noOutline);
    // holder: Product form containers or Upsell products in Cart form
    let holder = this.button.closest(s.selectors$J.productForm)
      ? this.button.closest(s.selectors$J.productForm)
      : this.button.closest(s.selectors$J.upsellHolder);
    let errorContainer = holder.querySelector(s.selectors$J.formErrorsContainer);

    // Upsell products in Cart form
    if (buttonUpsellHolder) {
      errorContainer = buttonUpsellHolder.querySelector(s.selectors$J.formErrorsContainer);
    }

    if (
      this.cartDrawerEnabled &&
      this.button &&
      this.button.closest(s.selectors$J.cartDrawer) !== null &&
      !this.button.closest(s.selectors$J.cartDrawer)
    ) {
      this.closeCartDrawer();
    }

    this.button.classList.remove(c.classes$z.loading);
    this.button.removeAttribute(a.attributes$s.disabled);

    // Error message content
    const closeErrorButton = buttonQuickBuyForm
      ? ''
      : `
  <button type="button" class="errors__button-close" data-close-error>
    ${theme.icons.close}
  </button>
`;

    let errorMessages = `${data.message}: ${data.description}`;
    if (this.recipientErrors && data.description && typeof data.description === 'object') {
      errorMessages = Object.entries(data.description)
        .map(([key, value]) => `${value}`)
        .join('<br>');
    }

    errorContainer.innerHTML = `
  <div class="errors" data-error autofocus>
    ${errorMessages}
    ${closeErrorButton}
  </div>
`;

    // Quick buy in PGI errors
    if (buttonQuickBuyForm) {
      const productMediaContainer = errorContainer.closest(s.selectors$J.productMediaContainer);
      productMediaContainer.classList.add(c.classes$z.productGridImageError);

      errorContainer.querySelector(s.selectors$J.error).addEventListener('animationend', () => {
        productMediaContainer.classList.remove(c.classes$z.productGridImageError);
        errorContainer.innerHTML = '';

        if (!isFocusEnabled) {
          document.activeElement.blur();
        }
      });
    } else {
      // PDP form, Quick view popup forms and Upsell sliders errors
      errorContainer.classList.add(c.classes$z.visible);
      errorContainer.addEventListener('transitionend', () => {
        this.resizeSliders(errorContainer);
      });

      this.handleCloseErrorMessages(errorContainer);
    }
  }

  /**
   * Handle close buttons in error messages containers
   *
   * @param   {Object}  The error container that holds the close button
   * @return  {Void}
   */
  handleCloseErrorMessages(container) {
    const formErrorClose = container.querySelector(s.selectors$J.formCloseError);

    formErrorClose?.addEventListener('click', (event) => {
      const clickedElement = event.target;
      const isFormCloseError =
        clickedElement.matches(s.selectors$J.formCloseError) || clickedElement.closest(s.selectors$J.formCloseError);

      if (!isFormCloseError) return;

      event.preventDefault();
      container.classList.remove(c.classes$z.visible);
      container.querySelector(s.selectors$J.error).addEventListener('transitionend', () => {
        container.innerHTML = '';
        this.resizeSliders(clickedElement);
      });
    });

    this.focusOnErrorMessage(container, formErrorClose);
  }

  /**
   * Focus on the error container's close button so that the alert message is read outloud on voiceover assistive technologies
   *
   * @param   {Object}  The error container that holds the error message
   * @param   {Object}  The button that closes the error message
   * @return  {Void}
   */
  focusOnErrorMessage(container, button) {
    const isFocusEnabled = !document.body.classList.contains(c.classes$z.noOutline);

    if (!isFocusEnabled) return;

    container.addEventListener('transitionend', () => {
      requestAnimationFrame(() => button?.focus({ focusVisible: true }));
    });
  }

  /**
   * Hide error message container as soon as an item is successfully added to the cart
   */
  hideAddToCartErrorMessage() {
    const holder = this.button.closest(s.selectors$J.upsellHolder)
      ? this.button.closest(s.selectors$J.upsellHolder)
      : this.button.closest(s.selectors$J.productForm);
    const errorContainer = holder?.querySelector(s.selectors$J.formErrorsContainer);
    errorContainer?.classList.remove(c.classes$z.visible);
  }

  /**
   * Resize sliders height
   *
   * @param   {Object}  Element within the slider container that would be resized
   * @return  {Void}
   */
  resizeSliders(element) {
    const slider = element.closest(s.selectors$J.flickityEnabled);

    if (!slider) return;

    const flkty = Flickity.data(slider);
    requestAnimationFrame(() => flkty.resize());
  }

  /**
   * Render cart and define all elements after cart drawer is open for a first time
   *
   * @return  {Void}
   */
  renderCartDrawer(alwaysOpen = true) {
    const cartDrawerTemplate = document.querySelector(s.selectors$J.cartDrawerTemplate);

    if (!cartDrawerTemplate) {
      return;
    }

    // Append cart items HTML to the cart drawer container
    this.cartDrawer.innerHTML = cartDrawerTemplate.innerHTML;
    this.assignArguments();

    // Bind cart quantity events
    this.initQuantity();

    // Bind cart events
    this.cartEvents();

    // Init collapsible function for the cart drawer accordions
    if (this.buttonHolder) {
      this.collapsible = new Collapsible(this.buttonHolder);
    }

    // Bind cart drawer close button event
    this.cartDrawerToggle = this.cartDrawer.querySelector(s.selectors$J.cartDrawerToggle);
    this.cartDrawerToggle.addEventListener('click', this.cartDrawerToggleClickEvent);

    this.isCartDrawerLoaded = true;

    this.renderPairProducts();

    // Hook for cart drawer loaded event
    document.dispatchEvent(new CustomEvent('theme:cart:loaded', { bubbles: true }));

    // Open cart drawer after cart items and events are loaded
    if (alwaysOpen) {
      this.openCartDrawer();
    }
  }

  /**
   * Open cart dropdown and add class on body
   *
   * @return  {Void}
   */

  openCartDrawer() {


    if (this.isCartDrawerOpen) {
      return;
    }

    if (!this.isCartDrawerLoaded) {
      this.renderCartDrawer();
      return;
    }

    // Hook for cart drawer open event
    document.dispatchEvent(new CustomEvent('theme:cart:open', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true, detail: this.cartDrawer }));
    document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true, detail: this.cartDrawerBody }));

    document.body.classList.add(c.classes$z.cartDrawerOpen);
    this.cartDrawer.classList.add(c.classes$z.open);
    this.cartDrawer.classList.remove(c.classes$z.contentVisibilityHidden);

    // Cart elements opening animation
    this.cartDrawer.querySelectorAll(s.selectors$J.aos).forEach((item) => {
      requestAnimationFrame(() => {
        item.classList.add(c.classes$z.aosAnimate);
      });
    });

    this.cartToggleButtons.forEach((button) => {
      button.setAttribute(a.attributes$s.ariaExpanded, true);
    });

    this.a11y.trapFocus({
      container: this.cartDrawer,
    });

    // Observe Additional Checkout Buttons
    this.observeAdditionalCheckoutButtons();
    this.isCartDrawerOpen = true;

    if(this.isCartDrawerOpen){
      console.log('Kris - cart is open');
      const trayContainer = document.getElementById('byob-tray-container');
      trayContainer.classList.remove('z-[9000]');
    }
  }

  /**
   * Close cart dropdown and remove class on body
   *
   * @return  {Void}
   */

  closeCartDrawer() {
    if (!this.isCartDrawerOpen) {
      return;
    }

    // Hook for cart drawer close event
    document.dispatchEvent(new CustomEvent('theme:cart:close', { bubbles: true }));

    // Cart elements closing animation

    if (this.cartAnimationTimer) {
      clearTimeout(this.cartAnimationTimer);
    }

    this.cartAnimationTimer = setTimeout(() => {
      this.cartDrawer.querySelectorAll(s.selectors$J.aos).forEach((item) => {
        item.classList.remove(c.classes$z.aosAnimate);
      });
    }, 300);

    this.cartErrorHolder.classList.remove(c.classes$z.expanded);

    this.a11y.removeTrapFocus();

    this.cartToggleButtons.forEach((button) => {
      button.setAttribute(a.attributes$s.ariaExpanded, false);
    });

    document.body.classList.remove(c.classes$z.cartDrawerOpen);
    this.cartDrawer.classList.remove(c.classes$z.open);
    this.itemsHolder.classList.remove(c.classes$z.updated);

    const onCartDrawerTransitionEnd = (event) => {
      if (event.target !== this.cartDrawer) return;

      requestAnimationFrame(() => {
        this.cartDrawer.classList.add(c.classes$z.contentVisibilityHidden);
      });

      this.cartDrawer.removeEventListener('transitionend', onCartDrawerTransitionEnd);
    };

    this.cartDrawer.addEventListener('transitionend', onCartDrawerTransitionEnd);

    // Fixes header background update on cart-drawer close
    const isFocusEnabled = !document.body.classList.contains(c.classes$z.noOutline);
    if (!isFocusEnabled) {
      requestAnimationFrame(() => {
        document.activeElement.blur();
      });
    }

    // Enable page scroll right after the closing animation ends
    const timeout = 400;
    document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true, detail: timeout }));

    this.isCartDrawerOpen = false;

  }

  /**
   * Toggle cart dropdown
   *
   * @return  {Void}
   */

  toggleCartDrawer() {
    if (this.isCartDrawerOpen) {
      this.closeCartDrawer();
    } else {
      this.openCartDrawer();
    }
  }

  /**
   * Cart drawer toggle events
   *
   * @return  {Void}
   */

  cartDrawerToggleEvents() {
    if (!this.cartDrawer) return;

    // Close cart drawer on ESC key pressed
    this.cartDrawer.addEventListener('keyup', (event) => {
      if (event.code === theme.keyboardKeys.ESCAPE) {
        this.closeCartDrawer();
      }
    });

    // Define cart drawer toggle button click event
    this.cartDrawerToggleClickEvent = (event) => {
      event.preventDefault();
      const button = event.target;

      if (button.getAttribute(a.attributes$s.ariaExpanded) === 'false') {
        this.a11y.state.trigger = button;
      }

      this.toggleCartDrawer();
    };

    // Define cart drawer close event
    this.cartDrawerCloseEvent = (event) => {
      const isCartDrawerToggle = event.target.matches(s.selectors$J.cartDrawerToggle);
      const isCartDrawerChild = document.querySelector(s.selectors$J.cartDrawer).contains(event.target);
      const isPopupQuickView = event.target.closest(s.selectors$J.popupQuickView);

      if (!isCartDrawerToggle && !isCartDrawerChild && !isPopupQuickView) {
        this.closeCartDrawer();
      }
    };

    // Bind cart drawer toggle buttons click event
    this.cartToggleButtons.forEach((button) => {
      button.addEventListener('click', this.cartDrawerToggleClickEvent);
    });

    // Close drawers on click outside
    //   Replaced 'click' with 'mousedown' as a quick and simple fix to the dragging issue on the upsell slider
    //   which was causing the cart-drawer to close when we start dragging the slider and finish our drag outside the cart-drawer
    //   which was triggering the 'click' event
    document.addEventListener('mousedown', this.cartDrawerCloseEvent);
  }

  /**
   * Toggle classes on different containers and messages
   *
   * @return  {Void}
   */

  toggleClassesOnContainers() {
    const that = this;

    this.emptyMessage.classList.toggle(c.classes$z.hidden, that.hasItemsInCart());
    this.buttonHolder.classList.toggle(c.classes$z.hidden, !that.hasItemsInCart());
    this.itemsHolder.classList.toggle(c.classes$z.hidden, !that.hasItemsInCart());
    this.cartItemsQty.classList.toggle(c.classes$z.hidden, !that.hasItemsInCart());
  }

  /**
   * Build cart depends on results
   *
   * @param   {Object}  data
   *
   * @return  {Void}
   */

  build(data) {
    const cartItemsData = data.querySelector(s.selectors$J.apiLineItems);
    const upsellItemsData = data.querySelector(s.selectors$J.apiUpsellItems);
    const cartEmptyData = Boolean(cartItemsData === null && upsellItemsData === null);
    const priceData = data.querySelector(s.selectors$J.apiCartPrice);
    const cartTotal = data.querySelector(s.selectors$J.cartTotal);

    // Store previous state for announcements
    const previousItemCount = this.totalItems || 0;
    const previousSubtotal = this.subtotal || 0;

    if (this.priceHolder && priceData) {
      this.priceHolder.innerHTML = priceData.innerHTML;
    }

    // Cart page empty state animations re-init
    this.emptyMessage.querySelectorAll(s.selectors$J.aos).forEach((item) => {
      item.classList.remove(c.classes$z.aosAnimate);
    });

    if (cartEmptyData) {
      this.itemsHolder.innerHTML = '';

      if (this.pairProductsHolder) {
        this.pairProductsHolder.innerHTML = '';
      }
    } else {
      this.itemsHolder.innerHTML = cartItemsData.innerHTML;

      if (this.pairProductsHolder) {
        this.pairProductsHolder.innerHTML = upsellItemsData.innerHTML;
      }

      this.renderPairProducts();
    }

    this.newTotalItems =
      cartItemsData && cartItemsData.querySelectorAll(s.selectors$J.item).length
        ? cartItemsData.querySelectorAll(s.selectors$J.item).length
        : 0;
    this.subtotal =
      cartTotal && cartTotal.hasAttribute(a.attributes$s.cartTotal)
        ? parseInt(cartTotal.getAttribute(a.attributes$s.cartTotal))
        : 0;
    this.cartCount = this.getCartItemCount();

    if (this.cartMessage.length > 0) {
      this.updateProgress();
    }

    this.cartToggleButtons.forEach((button) => {
      button.classList.remove(c.classes$z.cartItems);

      if (this.newTotalItems > 0) {
        button.classList.add(c.classes$z.cartItems);
      }
    });

    this.toggleErrorMessage();
    this.updateItemsQuantity(this.cartCount);

    // Update cart total price
    const formattedTotal = this.subtotal === 0
      ? window.theme.strings.free
      : themeCurrency.formatMoney(this.subtotal, theme.moneyWithCurrencyFormat);
    this.cartTotalPrice.innerHTML = formattedTotal;

    // Announce cart updates to screen readers
    this.announceCartUpdate(previousItemCount, previousSubtotal, cartEmptyData);

    if (this.totalItems !== this.newTotalItems) {
      this.totalItems = this.newTotalItems;

      this.toggleClassesOnContainers();
    }

    // Add class "is-updated" line items holder to reduce cart items animation delay via CSS variables
    if (this.isCartDrawerOpen) {
      this.itemsHolder.classList.add(c.classes$z.updated);
    }

    this.cartEvents();
    this.initQuantity();
    this.enableCartButtons();
    this.resetButtonClasses();
    this.removeLoadingClass();

    document.dispatchEvent(new CustomEvent('theme:cart:added', { bubbles: true }));

    if (this.cartDrawer) {
      this.openCartDrawer();
    }
  }

  /**
   * Announce item removal to screen readers
   *
   * @param   {String}  itemTitle  Title of the removed item
   * @return  {Void}
   */
  announceItemRemoval(itemTitle) {
    const announcementElement = this.cart?.querySelector('[data-cart-update-announcement]');
    if (!announcementElement) return;

    const announcement = `${itemTitle} removed from cart.`;
    announcementElement.textContent = '';
    setTimeout(() => {
      announcementElement.textContent = announcement;
    }, 100);
  }

  /**
   * Announce quantity change to screen readers
   *
   * @param   {String}  itemTitle        Title of the item
   * @param   {Number}  previousQuantity Previous quantity
   * @param   {Number}  newQuantity      New quantity
   * @return  {Void}
   */
  announceQuantityChange(itemTitle, previousQuantity, newQuantity) {
    const announcementElement = this.cart?.querySelector('[data-cart-update-announcement]');
    if (!announcementElement) return;

    const announcement = `${itemTitle} quantity changed from ${previousQuantity} to ${newQuantity}.`;
    announcementElement.textContent = '';
    setTimeout(() => {
      announcementElement.textContent = announcement;
    }, 100);
  }

  /**
   * Announce cart updates to screen readers
   *
   * @param   {Number}  previousItemCount  Previous number of items in cart
   * @param   {Number}  previousSubtotal   Previous cart subtotal
   * @param   {Boolean} cartEmptyData       Whether cart is empty
   * @return  {Void}
   */
  announceCartUpdate(previousItemCount, previousSubtotal, cartEmptyData = false) {
    const announcementElement = this.cart?.querySelector('[data-cart-update-announcement]');
    if (!announcementElement) return;

    let announcement = '';

    // Handle empty cart
    if (cartEmptyData && previousItemCount > 0) {
      announcement = 'Cart is now empty.';
    }
    // Handle item removal
    else if (this.newTotalItems < previousItemCount) {
      const itemsRemoved = previousItemCount - this.newTotalItems;
      const itemText = itemsRemoved === 1 ? 'item' : 'items';
      announcement = `${itemsRemoved} ${itemText} removed from cart.`;
    }
    // Handle item addition
    else if (this.newTotalItems > previousItemCount && previousItemCount > 0) {
      const itemsAdded = this.newTotalItems - previousItemCount;
      const itemText = itemsAdded === 1 ? 'item' : 'items';
      announcement = `${itemsAdded} ${itemText} added to cart.`;
    }
    // Handle quantity change (same number of line items but different total quantity)
    else if (this.newTotalItems === previousItemCount && this.cartCount !== previousItemCount) {
      const quantityDiff = this.cartCount - previousItemCount;
      if (quantityDiff > 0) {
        announcement = `Quantity increased. Cart now has ${this.cartCount} ${this.cartCount === 1 ? 'item' : 'items'}.`;
      } else if (quantityDiff < 0) {
        announcement = `Quantity decreased. Cart now has ${this.cartCount} ${this.cartCount === 1 ? 'item' : 'items'}.`;
      }
    }
    // Handle total price change
    if (this.subtotal !== previousSubtotal && this.subtotal > 0 && previousSubtotal > 0) {
      const formattedTotal = themeCurrency.formatMoney(this.subtotal, theme.moneyWithCurrencyFormat);
      if (announcement) {
        announcement += ` New total: ${formattedTotal}.`;
      } else {
        announcement = `Cart total updated to ${formattedTotal}.`;
      }
    }
    // Handle first item added
    else if (this.newTotalItems === 1 && previousItemCount === 0) {
      const formattedTotal = themeCurrency.formatMoney(this.subtotal, theme.moneyWithCurrencyFormat);
      announcement = `Item added to cart. Cart total: ${formattedTotal}.`;
    }
    // Handle cart total when items exist
    else if (this.subtotal > 0 && announcement) {
      const formattedTotal = themeCurrency.formatMoney(this.subtotal, theme.moneyWithCurrencyFormat);
      announcement += ` Cart total: ${formattedTotal}.`;
    }

    // Only announce if there's something to announce
    if (announcement) {
      // Clear and set text to trigger aria-live announcement
      announcementElement.textContent = '';
      // Use setTimeout to ensure the announcement is triggered
      setTimeout(() => {
        announcementElement.textContent = announcement;
      }, 100);
    }
  }

  /**
   * Get cart item count
   *
   * @return  {Void}
   */

  getCartItemCount() {
    // Returning 0 and not the actual cart items count is done only for when "Cart type" settings are set to "Page"
    // The actual count is necessary only when we build and render the cart/cart-drawer after we get a response from the Cart API
    if (!this.cart) return 0;
    return Array.from(this.cart.querySelectorAll(s.selectors$J.qtyInput)).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );
  }

  /**
   * Check for items in the cart
   *
   * @return  {Void}
   */

  hasItemsInCart() {
    return this.totalItems > 0;
  }

  /**
   * Show/hide free shipping message
   *
   * @param   {Number}  total
   *
   * @return  {Void}
   */

  freeShippingMessageHandle(total) {
    if (this.cartMessage.length > 0) {
      document.querySelectorAll(s.selectors$J.cartMessage).forEach((message) => {
        const hasFreeShipping =
          message.hasAttribute(a.attributes$s.cartMessageValue) &&
          message.getAttribute(a.attributes$s.cartMessageValue) === 'true' &&
          total !== 0;
        const cartMessageDefault = message.querySelector(s.selectors$J.cartMessageDefault);

        message.classList.toggle(c.classes$z.success, total >= this.cartFreeLimitShipping && hasFreeShipping);
        message.classList.toggle(c.classes$z.isHidden, total === 0);
        cartMessageDefault.classList.toggle(c.classes$z.isHidden, total >= this.cartFreeLimitShipping);
      });
    }
  }

  /**
   * Update progress when update cart
   *
   * @return  {Void}
   */

  updateProgress() {
    const newPercentValue = (this.subtotal / this.cartFreeLimitShipping) * 100;
    const newPercentRounded = Math.round(newPercentValue);
    const clampedPercent = Math.max(0, Math.min(100, newPercentRounded));
    const leftToSpend = theme.settings.currency_code_enable
      ? themeCurrency.formatMoney(this.cartFreeLimitShipping - this.subtotal, theme.moneyWithCurrencyFormat)
      : themeCurrency.formatMoney(this.cartFreeLimitShipping - this.subtotal, theme.moneyFormat);
    const hasQualifiedFreeShipping = this.subtotal / this.cartFreeLimitShipping >= 1;
    const leftToSpendFormatted = leftToSpend.replace('.00', '').replace(',00', '');

    if (this.cartMessage.length > 0) {
      document.querySelectorAll(s.selectors$J.cartMessage).forEach((message) => {
        const cartMessageProgressItems = message.querySelectorAll(s.selectors$J.cartProgress);
        const leftToSpendMessage = message.querySelector(s.selectors$J.leftToSpend);
        const shippingStatusAnnouncement = message.querySelector('[data-shipping-status-announcement]');
        const shippingProgressAnnouncement = message.querySelector('[data-shipping-progress-announcement]');
        const messageDefault = message.querySelector(s.selectors$J.cartMessageDefault);
        const qualifiedMessage = message.querySelector('.cart__message__success');

        if (leftToSpendMessage) {
          leftToSpendMessage.innerHTML = leftToSpendFormatted;
        }

        // Update progressbar attributes on messageDefault when content changes
        if (messageDefault) {
          const messageText = messageDefault.textContent?.trim() || '';
          
          // Update progressbar ARIA attributes
          messageDefault.setAttribute('aria-valuenow', clampedPercent);
          
          // Create a descriptive aria-label from the message content
          let ariaLabelText;
          if (hasQualifiedFreeShipping) {
            ariaLabelText = 'Free shipping qualified';
            // Hide the progressbar when qualified
            messageDefault.setAttribute('aria-hidden', 'true');
          } else {
            ariaLabelText = `Free shipping progress: ${clampedPercent} percent complete. ${messageText}`;
            messageDefault.removeAttribute('aria-hidden');
          }
          messageDefault.setAttribute('aria-label', ariaLabelText);
        }

        if (cartMessageProgressItems.length) {
          cartMessageProgressItems.forEach((cartMessageProgress, index) => {
            const shouldHide = hasQualifiedFreeShipping;
            cartMessageProgress.classList.toggle(c.classes$z.isHidden, shouldHide);
            cartMessageProgress.style.setProperty('--progress-width', `${newPercentValue}%`);
            
            // Update ARIA attributes on the first progress bar (the accessible one)
            if (index === 0) {
              cartMessageProgress.setAttribute(a.attributes$s.value, clampedPercent);
              cartMessageProgress.setAttribute('aria-valuenow', clampedPercent);
              
              // Update aria-label with current status
              let progressLabel;
              if (hasQualifiedFreeShipping) {
                progressLabel = qualifiedMessage?.textContent?.trim() || 'Free shipping qualified';
              } else {
                const defaultMessage = messageDefault?.textContent?.trim() || '';
                progressLabel = `Free shipping progress: ${clampedPercent} percent complete. ${defaultMessage}`;
              }
              cartMessageProgress.setAttribute('aria-label', progressLabel);
            }
          });
        }

        // Announce status changes via aria-live region
        if (hasQualifiedFreeShipping && shippingStatusAnnouncement) {
          // Announce when free shipping is achieved
          const announcementText = qualifiedMessage?.textContent?.trim() || 'Free shipping qualified';
          // Only announce if the text has changed to avoid redundant announcements
          if (shippingStatusAnnouncement.textContent.trim() !== announcementText) {
            shippingStatusAnnouncement.textContent = announcementText;
            // Also ensure messageDefault announces the status change
            if (messageDefault) {
              messageDefault.setAttribute('aria-live', 'assertive');
              // Temporarily update to trigger announcement
              const currentText = messageDefault.textContent;
              messageDefault.textContent = announcementText;
              setTimeout(() => {
                if (messageDefault.textContent === announcementText) {
                  messageDefault.textContent = currentText;
                }
                messageDefault.setAttribute('aria-live', 'polite');
              }, 100);
            }
          }
        } else if (!hasQualifiedFreeShipping && shippingProgressAnnouncement) {
          // Announce progress updates - only when there's a significant change (5% or more)
          const progressText = `Free shipping progress: ${clampedPercent} percent complete. ${leftToSpendFormatted} left to qualify for free shipping.`;
          const lastPercent = parseInt(shippingProgressAnnouncement.getAttribute('data-last-percent') || '0');
          // Announce if percent changed by 5 or more, or if we reached a milestone (25%, 50%, 75%, 100%)
          const percentChanged = Math.abs(clampedPercent - lastPercent);
          const isMilestone = [25, 50, 75, 100].includes(clampedPercent);
          
          if (percentChanged >= 5 || isMilestone || clampedPercent === 0) {
            shippingProgressAnnouncement.textContent = progressText;
            shippingProgressAnnouncement.setAttribute('data-last-percent', clampedPercent);
          }
          // Ensure messageDefault also announces updates
          if (messageDefault) {
            messageDefault.setAttribute('aria-live', 'polite');
          }
        }

        this.freeShippingMessageHandle(this.subtotal);
      });
    }
  }

  /**
   * Render Upsell Products
   */
  renderPairProducts() {
    this.flktyUpsell = null;
    this.pairProductsHolder = document.querySelector(s.selectors$J.pairProductsHolder);
    this.pairProducts = document.querySelector(s.selectors$J.pairProducts);
    this.upsellHolders = document.querySelectorAll(s.selectors$J.upsellHolder);

    if (this.pairProductsHolder === null || this.pairProductsHolder === undefined) {
      return;
    }

    // Upsell slider
    const that = this;
    if (this.upsellHolders.length > 1) {
      this.flktyUpsell = new Flickity(this.pairProducts, {
        wrapAround: true,
        pageDots: true,
        adaptiveHeight: true,
        prevNextButtons: false,
        on: {
          ready: function () {
            new QuickViewPopup(that.cart);
            this.reloadCells();
            requestAnimationFrame(() => this.resize());
          },
        },
      });

      return;
    }

    // Single upsell item
    new QuickViewPopup(this.cart);
  }

  updateItemsQuantity(itemsQty) {
    let oneItemText = theme.strings.cart_items_one;
    let manyItemsText = theme.strings.cart_items_many;
    oneItemText = oneItemText.split('}}')[1];
    manyItemsText = manyItemsText.split('}}')[1];

    if (this.cartItemsQty) {
      this.cartItemsQty.textContent = itemsQty === 1 ? `${itemsQty} ${oneItemText}` : `${itemsQty} ${manyItemsText}`;
    }
  }

  /**
   * Ensure cart page keyboard accessibility
   * 
   * @return  {Void}
   */
  ensureCartPageKeyboardAccess() {
    // Ensure all interactive elements are keyboard accessible
    const ensureKeyboardAccess = () => {
      // Find all interactive elements that might not be keyboard accessible
      const allInteractiveElements = this.cart.querySelectorAll(
        'button:not([disabled]):not([aria-disabled="true"]), ' +
        'a[href]:not([tabindex="-1"]), ' +
        'input:not([disabled]):not([type="hidden"]), ' +
        'select:not([disabled]), ' +
        'textarea:not([disabled]), ' +
        '[role="button"]:not([aria-disabled="true"]), ' +
        '[tabindex]:not([tabindex^="-"])'
      );

      allInteractiveElements.forEach((element) => {
        // Skip if element is hidden
        const style = getComputedStyle(element);
        if (style.display === 'none' || 
            style.visibility === 'hidden' ||
            element.getAttribute('aria-hidden') === 'true') {
          return;
        }

        // Ensure elements with role="button" are focusable
        if (element.getAttribute('role') === 'button' && 
            !element.hasAttribute('tabindex') &&
            element.tagName !== 'BUTTON') {
          element.setAttribute('tabindex', '0');
        }
      });
    };

    // Run on page load and after a delay for dynamically loaded content
    ensureKeyboardAccess();
    setTimeout(ensureKeyboardAccess, 500);
    setTimeout(ensureKeyboardAccess, 1500);
  }

  observeAdditionalCheckoutButtons() {
    // identify an element to observe
    const additionalCheckoutButtons = this.cart.querySelector(s.selectors$J.additionalCheckoutButtons);
    if (additionalCheckoutButtons) {
      // Ensure additional checkout buttons are keyboard accessible
      const ensureKeyboardAccess = () => {
        // Find all interactive elements within additional checkout buttons - be more aggressive
        // Include shopify-cleanslate structure and nested elements
        const interactiveElements = additionalCheckoutButtons.querySelectorAll(
          'div[role="button"], button, a[href], input, [tabindex], iframe, form, ' +
          '.shopify-cleanslate div[role="button"], .shopify-cleanslate button, ' +
          '.shopify-cleanslate a, .dynamic-checkout__content div[role="button"], ' +
          '.dynamic-checkout__content button, .dynamic-checkout__content a'
        );
        
        interactiveElements.forEach((element) => {
          // Skip if element is disabled or hidden
          if (element.hasAttribute('disabled') || 
              element.getAttribute('aria-disabled') === 'true' ||
              element.getAttribute('aria-hidden') === 'true' ||
              getComputedStyle(element).display === 'none' ||
              getComputedStyle(element).visibility === 'hidden') {
            return;
          }

          // For elements with role="button" or divs that act as buttons (including Google Pay, Apple Pay, etc.)
          if (element.getAttribute('role') === 'button' || 
              (element.tagName === 'DIV' && (element.onclick || element.getAttribute('data-testid') || element.closest('[role="button"]')))) {
            // Force tabindex="0" for button-like divs
            if (element.getAttribute('tabindex') === '-1' || element.getAttribute('tabindex') === null) {
              element.setAttribute('tabindex', '0');
            }
            // Ensure pointer events are enabled
            element.style.pointerEvents = 'auto';
            // Ensure it's not hidden from screen readers
            if (element.getAttribute('aria-hidden') === 'true') {
              element.removeAttribute('aria-hidden');
            }
          }
          // For naturally focusable elements, ensure they're not blocked
          else if (element.tagName === 'BUTTON' || element.tagName === 'A' || element.tagName === 'INPUT') {
            if (element.getAttribute('tabindex') === '-1') {
              element.removeAttribute('tabindex');
            }
            element.style.pointerEvents = 'auto';
          }
          // For other elements, ensure they're focusable if they have interactive behavior
          else if (element.getAttribute('tabindex') === '-1') {
            element.removeAttribute('tabindex');
          }
        });

        // Handle iframes - ensure they can receive focus (Google Pay often uses iframes)
        // Note: Cross-origin iframes have security restrictions, so we wrap them in a focusable button
        const iframes = additionalCheckoutButtons.querySelectorAll('iframe');
        iframes.forEach((iframe) => {
          // Check if iframe is already wrapped in a focusable container
          let wrapper = iframe.closest('[data-iframe-wrapper]');
          
          if (!wrapper) {
            // Create a focusable button wrapper around the iframe
            wrapper = document.createElement('button');
            wrapper.setAttribute('type', 'button');
            wrapper.setAttribute('tabindex', '0');
            wrapper.setAttribute('role', 'button');
            wrapper.setAttribute('data-iframe-wrapper', 'true');
            wrapper.setAttribute('aria-label', 'Additional checkout option - Press Enter or Space to activate');
            wrapper.style.position = 'relative';
            wrapper.style.display = 'block';
            wrapper.style.width = '100%';
            wrapper.style.border = 'none';
            wrapper.style.background = 'transparent';
            wrapper.style.padding = '0';
            wrapper.style.margin = '0';
            wrapper.style.cursor = 'pointer';
            wrapper.style.outline = 'none';
            wrapper.style.fontFamily = 'inherit';
            
            // Insert wrapper before iframe and move iframe inside
            iframe.parentNode.insertBefore(wrapper, iframe);
            wrapper.appendChild(iframe);
            
            // Make wrapper handle keyboard events to activate the iframe
            wrapper.addEventListener('keydown', (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                // Try to focus and activate the iframe
                iframe.focus();
                // Click the wrapper which should activate the button inside iframe
                wrapper.click();
              }
            });
            
            // Handle focus styles for accessibility
            wrapper.addEventListener('focus', () => {
              if (!document.body.classList.contains('no-outline')) {
                wrapper.style.outline = '2px solid';
                wrapper.style.outlineOffset = '2px';
              }
            });
            
            wrapper.addEventListener('blur', () => {
              wrapper.style.outline = 'none';
            });
          }
          
          // Also ensure iframe itself is focusable as fallback
          iframe.setAttribute('tabindex', '0');
          
          // Add proper accessibility attributes to iframe
          if (!iframe.hasAttribute('title') && !iframe.hasAttribute('aria-label')) {
            iframe.setAttribute('title', 'Additional checkout option');
            iframe.setAttribute('aria-label', 'Additional checkout option');
          }
          
          // Ensure iframe can receive pointer events
          iframe.style.pointerEvents = 'auto';
          iframe.style.cursor = 'pointer';
          
          // Remove any aria-hidden that might hide it
          if (iframe.getAttribute('aria-hidden') === 'true') {
            iframe.removeAttribute('aria-hidden');
          }
          
          // Ensure parent containers don't block interaction
          let parent = wrapper.parentElement;
          while (parent && parent !== additionalCheckoutButtons) {
            const parentStyle = getComputedStyle(parent);
            if (parentStyle.pointerEvents === 'none') {
              parent.style.pointerEvents = 'auto';
            }
            parent = parent.parentElement;
          }
        });

        // Specifically handle shopify-cleanslate structure (where Google Pay buttons often are)
        const cleanslateButtons = additionalCheckoutButtons.querySelectorAll('.shopify-cleanslate div[role="button"]');
        cleanslateButtons.forEach((button) => {
          if (button.getAttribute('tabindex') === '-1' || button.getAttribute('tabindex') === null) {
            button.setAttribute('tabindex', '0');
          }
          button.style.pointerEvents = 'auto';
          if (button.getAttribute('aria-hidden') === 'true') {
            button.removeAttribute('aria-hidden');
          }
        });
      };

      // Run immediately and on a delay to catch dynamically loaded content
      // Google Pay buttons can load very late, so we check multiple times
      const runAndRetrap = () => {
        ensureKeyboardAccess();
        // Re-trap focus after ensuring keyboard access to include newly added iframes
        if (this.isCartDrawerOpen) {
          setTimeout(() => {
            this.a11y.removeTrapFocus();
            this.a11y.trapFocus({
              container: this.cart,
            });
          }, 50);
        }
      };
      
      runAndRetrap();
      setTimeout(runAndRetrap, 100);
      setTimeout(runAndRetrap, 300);
      setTimeout(runAndRetrap, 500);
      setTimeout(runAndRetrap, 1000);
      setTimeout(runAndRetrap, 2000);
      setTimeout(runAndRetrap, 3000);

      // create a new instance of `MutationObserver` named `observer`,
      // passing it a callback function
      const observer = new MutationObserver(() => {
        ensureKeyboardAccess();
        // Re-trap focus after ensuring keyboard access to include newly added iframes
        // Only re-trap focus if cart drawer is open
        if (this.isCartDrawerOpen) {
          // Use setTimeout to ensure DOM updates are complete
          setTimeout(() => {
            this.a11y.removeTrapFocus();
            this.a11y.trapFocus({
              container: this.cart,
            });
          }, 50);
        }
      });

      // call `observe()` on that MutationObserver instance,
      // passing it the element to observe, and the options object
      observer.observe(additionalCheckoutButtons, { 
        subtree: true, 
        childList: true, 
        attributes: true,
        attributeFilter: ['tabindex', 'disabled', 'aria-disabled', 'aria-hidden', 'style']
      });
      
      // Also observe for iframe load events
      const iframes = additionalCheckoutButtons.querySelectorAll('iframe');
      iframes.forEach((iframe) => {
        iframe.addEventListener('load', () => {
          ensureKeyboardAccess();
        });
      });
      
      // Watch for new iframes being added
      const iframeObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) { // Element node
              if (node.tagName === 'IFRAME') {
                ensureKeyboardAccess();
                node.addEventListener('load', () => {
                  ensureKeyboardAccess();
                });
              } else {
                const newIframes = node.querySelectorAll?.('iframe');
                if (newIframes) {
                  newIframes.forEach((iframe) => {
                    ensureKeyboardAccess();
                    iframe.addEventListener('load', () => {
                      ensureKeyboardAccess();
                    });
                  });
                }
              }
            }
          });
        });
      });
      
      iframeObserver.observe(additionalCheckoutButtons, {
        subtree: true,
        childList: true
      });
    }
  }

  formSubmitHandler() {
    const termsAccepted = document.querySelector(s.selectors$J.cartTermsCheckbox).checked;
    const termsError = document.querySelector(s.selectors$J.termsErrorMessage);

    // Disable form submit if terms and conditions are not accepted
    if (!termsAccepted) {
      if (document.querySelector(s.selectors$J.termsErrorMessage).length > 0) {
        return;
      }

      termsError.innerText = theme.strings.cart_acceptance_error;
      this.cartCheckoutButton.setAttribute(a.attributes$s.disabled, true);
      termsError.classList.add(c.classes$z.expanded);
    } else {
      termsError.classList.remove(c.classes$z.expanded);
      this.cartCheckoutButton.removeAttribute(a.attributes$s.disabled);
    }
  }

  resetButtonClasses() {
    const buttons = document.querySelectorAll(s.selectors$J.buttonAddToCart);
    if (buttons) {
      buttons.forEach((button) => {
        if (button.classList.contains(c.classes$z.loading)) {
          button.classList.remove(c.classes$z.loading);
          button.classList.add(c.classes$z.success);

          setTimeout(() => {
            button.removeAttribute(a.attributes$s.disabled);
            button.classList.remove(c.classes$z.success);
          }, stngs.settings$4.timers.addProductTimeout);
        }
      });
    }
  }

  addLoadingClass() {
    if (this.cartDrawer) {
      this.cartDrawer.classList.add(c.classes$z.loading);
    } else if (this.itemsWrapper) {
      this.itemsWrapper.classList.add(c.classes$z.loading);
    }
  }

  removeLoadingClass() {
    if (this.cartDrawer) {
      this.cartDrawer.classList.remove(c.classes$z.loading);
    } else if (this.itemsWrapper) {
      this.itemsWrapper.classList.remove(c.classes$z.loading);
    }
  }

  unload() {
    if (this.cartDrawerToggle) {
      this.cartDrawerToggle.removeEventListener('click', this.cartDrawerToggleClickEvent);
    }

    this.cartToggleButtons.forEach((button) => {
      button.removeEventListener('click', this.cartDrawerToggleClickEvent);
    });

    // Close drawers on click outside
    document.removeEventListener('mousedown', this.cartDrawerCloseEvent);

    if (this.collapsible !== null) {
      this.collapsible.onUnload();
    }
  }
}

